// extracted by mini-css-extract-plugin
export var orderSummary = "_t3-0";
export var showMoreLessButton = "_t3-1";